import { render } from "./scTrend.vue?vue&type=template&id=f1f055ec&scoped=true"
import script from "./scTrend.vue?vue&type=script&lang=js"
export * from "./scTrend.vue?vue&type=script&lang=js"

import "./scTrend.vue?vue&type=style&index=0&id=f1f055ec&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-f1f055ec"]])

export default __exports__